"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts_1 = require("../consts");
var mappers_1 = require("../mappers");
var utils_1 = require("../utils");
var createLoginEvent = function (event) {
    var loggedInData = {
        event: (event === null || event === void 0 ? void 0 : event.loggedInUser) ? "loggedin" : consts_1.NOT_AVAILABLE,
        eventInfo: (event === null || event === void 0 ? void 0 : event.loggedInUser) ? "loggedin" : consts_1.NOT_AVAILABLE,
        user: (0, mappers_1.mapLoginData)(event.loggedInUser)
    };
    return (0, utils_1.checkDataLayerValueEmpty)(loggedInData);
};
exports.default = createLoginEvent;
